// extracted by mini-css-extract-plugin
module.exports = {"AppContainer":"App_AppContainer__1ND0m"};